import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { getAccessToken } from "../../utils/auth";

const PrivateRoute = ({ children }) => {
  const accessToken = getAccessToken();
  return accessToken ? children : <Navigate to="/authentication/sign-in" />;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
